import {
  Box,
  Paper,
  Tabs,
  Tab,
  Stack,
  TextField,
  InputAdornment,
  Button,
  useTheme,
  Snackbar,
  Alert,
  Skeleton,
  Grid2,
  useMediaQuery,
  IconButton,
} from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import {
  Add,
  Search,
  CheckBox as CheckBoxIcon,
  CheckBoxOutlineBlank,
  MapOutlined,
  WifiFindOutlined,
  SwapVertOutlined,
} from "@mui/icons-material";

import { useOutletContext } from "react-router-dom";
import CardMapsHome from "../../../../componentes/easyMaps/cardMapsHome";
import NewMap from "../../../../componentes/easyMaps/newMap";
import CardMapsHomeRp from "../../../../componentes/easyMaps/cardMapsHomeRP";
import Alerts from "../../../../componentes/easyMaps/alerts";
import MenuSort from "../../../../componentes/easyMaps/sideBarEasyMapsRp/menuSort";
const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const useStyles = (theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    mt: 2,
    mb: 1,
  },
  body: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    gap: 2,
  },
  headerBox: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    width: "100%",
  },

  addIcon: { mt: -0.2 },
  headerPaper: {
    boxShadow: "0px 0px 5px  #0000001a",
    borderTopLeftRadius: "0px",
    padding: "16px",
    display: "flex",
    gap: "16px",
    flexDirection: "column",
    position: "relative",
    width: "100%",
  },

  button: { width: { xs: "100%", sm: "148px" }, minWidth: "148px" },
  buttonDialog: {
    color: theme?.palette?.color?.buttonConfirm || "primary.main",
  },
  textfield: { width: "360px" },
  tabs: {
    zIndex: 1,
    ml: "-2px",
    "& button": {
      ml: "2px",
      mt: "1px",
      backgroundColor: theme.palette.background.tab,
      boxShadow: "0px 0px 5px  #0000001a",
      color: theme.palette.text.disable,
      textTransform: "none",
      borderTopLeftRadius: "5px",
      borderTopRightRadius: "5px",
      minWidth: "120px",
      minHeight: "50px",
    },
    "& button.Mui-selected": {
      backgroundColor: theme.palette.background.paper,
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "transparent",
      border: "none",
    },
  },
});

export default function MapasGeolocalizadosEasyMaps() {
  const { maps, loadingPage, setMaps, handleApiGetMap } = useOutletContext();
  const [tabValue, setTabValue] = useState(0);
  const [anchorElOrder, setAnchorElOrder] = useState(null);
  const [directionSort, setDirectionSort] = useState(false);
  const [sort, setSort] = useState(0);
  const [openNovoMapaDialog, setOpenNovoMapaDialog] = useState(false);
  const [openNovoPopDialog, setOpenNovoPopDialog] = useState(false);
  const [snackbar, setSnackbar] = useState(null);
  const [textFilter, setTextFilter] = useState("");
  const handleCloseSnackbar = () => setSnackbar(null);
  const theme = useTheme();
  const styles = useStyles(theme);

  const [width, setWidth] = useState(window.innerWidth);
  const isSmDown = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    setTextFilter("");
  }, [tabValue]);

  useEffect(() => {
    window.addEventListener("resize", () => {
      setWidth(window.innerWidth);
    });
  }, []);

  const mapasFilter = useMemo(() => {
    // Filtra
    let result = maps.filter(
      (map) =>
        map.titulo.toLowerCase().includes(textFilter.toLowerCase()) &&
        map.tipo === 0,
    );
    console.log(result);

    // Ordena baseado no critério
    const comparators = {
      0: (a, b) => a.titulo.localeCompare(b.titulo),
      1: (a, b) => {
        // Soma todos os valores (value) dos alertas
        const totalA =
          a.alertas?.reduce((acc, alerta) => acc + (alerta.value || 0), 0) || 0;
        const totalB =
          b.alertas?.reduce((acc, alerta) => acc + (alerta.value || 0), 0) || 0;
        return totalA - totalB;
      },
      2: (a, b) =>
        (a.mapas?.length + a.pops?.length + a.hosts?.length || 0) -
        (b.mapas?.length + b.pops?.length + b.hosts?.length || 0),
    };

    if (sort !== undefined && comparators[sort]) {
      result = result.sort((a, b) => {
        const comparison = comparators[sort](a, b);
        return directionSort === false ? comparison : -comparison;
      });
    }
    return result;
  }, [maps, textFilter, sort, directionSort]);

  function deleteMapsInMaps(indexMap) {
    const newMaps = [...maps];
    newMaps.splice(indexMap, 1);
    setMaps(newMaps);
  }
  function addMapInMaps(map) {
    const newMaps = [...maps];
    newMaps.push(map);
    setMaps(newMaps);
  }

  function updateMapTokenInMaps(mapToken, indexMap) {
    let newMaps = [...maps];
    newMaps[indexMap]["mapToken"] = mapToken;
    setMaps(newMaps);
  }

  function updateTitleInMaps(newTitle, indexMap) {
    const newMaps = [...maps];
    newMaps[indexMap].titulo = newTitle;
    setMaps(newMaps);
  }

  return (
    <Box sx={styles.container}>
      <Box sx={styles.body}>
        <Stack width="100%">
          <Paper sx={styles.headerPaper}>
            <Box sx={styles.headerBox}>
              <Stack
                direction={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
                flexWrap={"wrap"}
                gap={1}
              >
                <Stack direction={"row"} alignItems={"center"} gap={0.5}>
                  <TextField
                    placeholder={"Buscar"}
                    autoComplete="off"
                    size="small"
                    fullWidth={isSmDown}
                    value={textFilter}
                    onChange={(event) => {
                      setTextFilter(event.target.value);
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor:
                          theme.palette.background.paperLinkedMaps,
                        boxShadow: "none",
                        width: { xs: "100%", sm: "300px" },
                        "&:hover": {
                          backgroundColor:
                            theme.palette.background.paperLinkedMaps,
                        },
                      },
                    }}
                    slotProps={{
                      input: {
                        endAdornment: (
                          <InputAdornment position="end">
                            <Search />
                          </InputAdornment>
                        ),
                      },
                    }}
                  />
                  <IconButton
                    size="small"
                    sx={{ width: "40px", height: "40px" }}
                    onClick={(event) => setAnchorElOrder(event.currentTarget)}
                  >
                    <SwapVertOutlined />
                  </IconButton>
                </Stack>

                <Button
                  color="primary"
                  variant="contained"
                  sx={styles.button}
                  endIcon={<Add sx={styles.addIcon} />}
                  onClick={() => {
                    setOpenNovoMapaDialog(true);
                  }}
                >
                  Novo Mapa
                </Button>
              </Stack>
            </Box>
          </Paper>
        </Stack>

        {loadingPage ? (
          <Box
            sx={{
              display: "flex",
              gap: 2,
              paddingLeft: 2,
              alignItems: "start",
              width: "100%",
              flexWrap: "wrap",
            }}
          >
            {Array.from({ length: 4 }).map((_, index) => (
              <Skeleton
                key={index}
                variant="rectangular"
                sx={{
                  width: "360px",
                  height: "180px",
                  borderRadius: "6px",
                  flex: "0 1 360px",
                }}
              />
            ))}
          </Box>
        ) : (
          <>
            <Grid2
              container
              spacing={2}
              sx={{
                justifyContent: { xs: "center", sm: "start" },
                width: "100%",
                paddingLeft: { xs: 0, sm: 2 },
              }}
            >
              {Array.isArray(mapasFilter) &&
                mapasFilter.length > 0 &&
                mapasFilter.map(
                  (map, index) =>
                    map?.tipo == 0 && (
                      <Grid2 key={index} xs={12} sm={6} md={4} lg={3}>
                        <CardMapsHome
                          key={index}
                          index={index}
                          id={map.id}
                          mapName={map.titulo}
                          tipo={map.tipo}
                          inGroup={false}
                          alertas={map.alertas}
                          hostsNames={[map.hosts]}
                          hostsCounts={map.hosts?.length || 0}
                          popsCounts={map.pops?.length || 0}
                          mapasCounts={map.mapas?.length || 0}
                          deleteMapsInMaps={deleteMapsInMaps}
                          duplicateMapsInMaps={handleApiGetMap}
                          updateTitleInMaps={updateTitleInMaps}
                          updateMapTokenInMaps={updateMapTokenInMaps}
                          setSnackbar={setSnackbar}
                          mapas={map?.mapas}
                          pops={map?.pops}
                          mapToken={map?.mapToken}
                        />
                      </Grid2>
                    ),
                )}
            </Grid2>
          </>
        )}
      </Box>
      <NewMap
        key={"newMapa-Main"}
        openNovoMapaDialog={openNovoMapaDialog}
        setOpenNovoMapaDialog={setOpenNovoMapaDialog}
        setSnackbar={setSnackbar}
        maps={maps}
        initialtab={1}
        addMapInMaps={addMapInMaps}
        tipoDefault={0}
      />
      <MenuSort
        anchorEl={anchorElOrder}
        setAnchorEl={setAnchorElOrder}
        options={["Nome", "Alertas", "Elementos"]}
        direction={directionSort}
        setDirection={setDirectionSort}
        sort={sort}
        setSort={setSort}
      />

      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={handleCloseSnackbar} />
        </Snackbar>
      )}
    </Box>
  );
}
